// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:400px){button.v-btn.documentButton[data-v-5fff9bf6]{padding-left:0}}", ""]);
// Exports
module.exports = exports;
